/**
 * Methods to be implemented in component:
 * - onBeforeUnload: to perform any actions before closing the window (e.g. warning of unsaved changes)
 * - onOutsideClick: to perform any actions when clicking outside the component's element (e.g. clicking document's body for a panel, or for a post)
 * - onWindowScroll
 * - onEscape
 * - onEnter
 */

const DELTA_X = 2
const DELTA_Y = 2
export default {
  data() {
    return {
      // A 'click' event will fire during a drag-and-drop because it has a mousedown followed by a mouseup.
      // This flag is used to differentiate drag-and-drop/text-selection and a true on-the-spot click.
      $_outsideEventsMixin_isTrueClick: false,
      $_outsideEventsMixin_clickStartingLocation: {},
      $_outsideEventsMixin_outsideClickHandler: () => {},
      $_outsideEventsMixin_escapeHandler: () => {},
      $_outsideEventsMixin_enterHandler: () => {},
    }
  },
  mounted() {
    if (this.onBeforeUnload) {
      window.addEventListener('beforeunload', this.onBeforeUnload)
    }
    if (this.onOutsideClick) {
      // the document.contains calls helps us filter out the times where a menu bar or something
      // is clicked on and the menu disappears soon after.
      // contains matches self
      this.$_outsideEventsMixin_outsideClickHandler = (e) => {
        if (!this.$_outsideEventsMixin_isTrueClick) return
        if (document.body.contains(e.target) && !this.$el.contains(e.target)) {
          this.onOutsideClick(e);
        }
        this.$_outsideEventsMixin_isTrueClick = false
      }
      // deferring it because without deferring
      // the click that potentially opened this
      // component can register
      setTimeout(() =>{
        document.body.addEventListener('mousedown', (e) => {
          this.$_outsideEventsMixin_isTrueClick = true
          this.$_outsideEventsMixin_clickStartingLocation = {
            pageX: e.pageX,
            pageY: e.pageY
          }

        })
        document.body.addEventListener('mousemove', (e) => {
          if (this.$_outsideEventsMixin_isTrueClick &&
             !!this.$_outsideEventsMixin_clickStartingLocation.pageX &&
             !!this.$_outsideEventsMixin_clickStartingLocation.pageY) {
            const diffX = e.pageX - this.$_outsideEventsMixin_clickStartingLocation.pageX
            const diffY = e.pageY - this.$_outsideEventsMixin_clickStartingLocation.pageY
            if (diffX > DELTA_X || diffX < -DELTA_X || diffY > DELTA_Y || diffY < -DELTA_Y) {
              this.$_outsideEventsMixin_isTrueClick = false
            }
          }
        })
        document.body.addEventListener('mouseup', () => {
          this.$_outsideEventsMixin_clickStartingLocation = {}
        })
        document.body.addEventListener('click', this.$_outsideEventsMixin_outsideClickHandler)
      }, 0)
    }
    if (this.onWindowScroll) {
      window.addEventListener('scroll', this.onWindowScroll)
    }
    if (this.onEscape) {
      this.$_outsideEventsMixin_escapeHandler = (e) => {
        if (e.keyCode === 27) {
          this.onEscape(e)
        }
      }
      window.addEventListener('keyup', this.$_outsideEventsMixin_escapeHandler)
    }
    if (this.onEnter) {
      this.$_outsideEventsMixin_enterHandler = (e) => {
        if (e.keyCode === 13) {
          this.onEnter(e)
        }
      }
      window.addEventListener('keyup', this.$_outsideEventsMixin_enterHandler)
    }
  },
  beforeDestroy() {
    if (this.onBeforeUnload) {
      window.removeEventListener('beforeunload', this.onBeforeUnload)
    }
    if (this.onOutsideClick) {
      document.body.removeEventListener('click', this.$_outsideEventsMixin_outsideClickHandler)
    }
    if (this.onWindowScroll) {
      window.removeEventListener('scroll', this.onWindowScroll)
    }
    if (this.onEscape) {
      window.removeEventListener('keyup', this.$_outsideEventsMixin_escapeHandler)
    }
    if (this.onEnter) {
      window.removeEventListener('keyup', this.$_outsideEventsMixin_enterHandler)
    }
  },
  methods: {
    pauseOutsideClickHandler () {
      document.body.removeEventListener('click', this.$_outsideEventsMixin_outsideClickHandler)
    },
    resumeOutsideClickHandler () {
      this.$_outsideEventsMixin_outsideClickHandler = (e) => {
        if (document.body.contains(e.target) && !this.$el.contains(e.target)) {
          this.onOutsideClick(e);
        }
      };
      setTimeout(() => {
        document.body.addEventListener('click', this.$_outsideEventsMixin_outsideClickHandler)
      }, 0);
    }
  }
}